import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useI18n } from '../i18n';
import { Check } from 'lucide-react';
import './coming-soon.css';

const AppleIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="#fff" aria-hidden="true">
    <path d="M17.05 12.53c-.02-2.06 1.68-3.05 1.76-3.1-0.96-1.4-2.45-1.6-2.98-1.62-1.27-.13-2.48.75-3.12.75-.64 0-1.64-.73-2.7-.71-1.39.02-2.67.81-3.38 2.05-1.44 2.5-.37 6.2 1.03 8.23.69.99 1.5 2.1 2.57 2.06 1.03-.04 1.42-.66 2.67-.66 1.24 0 1.6.66 2.69.64 1.11-.02 1.81-1.01 2.49-2 .78-1.15 1.1-2.26 1.12-2.32-.02-.01-2.15-.83-2.17-3.29zM15.1 6.15c.56-.69.94-1.63.84-2.58-.81.03-1.8.54-2.38 1.22-.52.6-.98 1.57-.86 2.49.9.07 1.83-.46 2.4-1.13z"/>
  </svg>
);

const PlayIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M3.6 2.3c-.2.2-.3.5-.3.9v17.6c0 .4.1.7.3.9l.1.1L13.5 12 3.7 2.2l-.1.1z" fill="#00d0ff"/>
    <path d="M17 15.3l-3.5-3.3 3.5-3.3 4.1 2.3c1.1.6 1.1 1.7 0 2.3L17 15.3z" fill="#ffce00"/>
    <path d="M3.7 21.8c.3.3.8.4 1.4.1L17 15.3l-3.5-3.3-9.8 9.8z" fill="#ff3d44"/>
    <path d="M3.7 2.2L13.5 12 17 8.7 5.1 2.1c-.6-.3-1.1-.2-1.4.1z" fill="#00e676"/>
  </svg>
);

export default function ComingSoon() {
  const { user } = useAuth();
  const { t } = useI18n();
  const c = t.comingSoon;
  const firstName = user?.name ? user.name.trim().split(/\s+/)[0] : '';

  return (
    <div className="cs-page" data-testid="coming-soon-page">
      <div className="cs-card">
        <div className="cs-logo-wrap">
          <span className="cs-halo" />
          <img src="/assets/hitmax_icon.webp" alt="HitMax" className="cs-logo" draggable={false} />
        </div>

        {firstName && (
          <div className="cs-badge-created" data-testid="coming-soon-created">
            <Check size={15} /> {c.createdPrefix}{firstName}
          </div>
        )}

        <h1 className="cs-title">{c.title}</h1>

        <p className="cs-subtitle">{c.subtitle}</p>

        <div className="cs-stores">
          <div className="cs-store" data-testid="store-appstore" aria-disabled="true">
            <span className="cs-store__soon">{c.soon}</span>
            <AppleIcon />
            <span className="cs-store__txt"><small>{c.appStoreSmall}</small><strong>{c.appStore}</strong></span>
          </div>
          <div className="cs-store" data-testid="store-googleplay" aria-disabled="true">
            <span className="cs-store__soon">{c.soon}</span>
            <PlayIcon />
            <span className="cs-store__txt"><small>{c.playSmall}</small><strong>{c.playStore}</strong></span>
          </div>
        </div>

        <p className="cs-notify">{c.notify}</p>

        <p className="cs-legal">{c.legal}</p>

        <Link to="/" className="cs-home" data-testid="coming-soon-home">{c.home}</Link>

        <div className="cs-foot-links">
          <Link to="/confidentialite">{t.pages.confidentialite}</Link>
          <Link to="/support">{t.pages.support}</Link>
          <Link to="/mentions-legales">{t.pages.mentions}</Link>
        </div>
      </div>
    </div>
  );
}
